import React from 'react';
import { Mail, Phone, Facebook, Twitter, Instagram, Linkedin } from 'lucide-react';
import '../app.css';

const Footer = () => {
    return (
        <footer className="bg-[#193763] text-white pt-12 pb-6">
            <div className="container mx-auto px-4">
                <div className="grid md:grid-cols-3 gap-8 mb-8 mx-12 justify-items-center">
                    <div>
                        <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="#our-products" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    Our Products
                                </a>
                            </li>
                            <li>
                                <a href="#become-a-merchant" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    Become a Merchant
                                </a>
                            </li>
                            <li>
                                <a href="#about-us" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    About Us
                                </a>
                            </li>
                            <li>
                                <a href="#tutorials" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    Tutorials
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Support</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="/help-center" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    Help Center
                                </a>
                            </li>
                            <li>
                                <a href="/faqs" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    FAQs
                                </a>
                            </li>
                            <li>
                                <a href="/privacy-policy" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    Privacy Policy
                                </a>
                            </li>
                            <li>
                                <a href="/terms-of-service" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    Terms of Service
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
                        <ul className="space-y-3">
                            <li className="flex items-center">
                                <Mail size={16} className="mr-2 text-[#3370C9]" />
                                <a href="mailto:info@hisabb.com" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    info@hisabb.com
                                </a>
                            </li>
                            <li className="flex items-center">
                                <Phone size={16} className="mr-2 text-[#3370C9]" />
                                <a href="tel:+1234567890" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                    +1 (234) 567-890
                                </a>
                            </li>
                        </ul>
                        <div className="flex space-x-4 mt-4">
                            <a href="https://www.facebook.com" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                <Facebook size={20} />
                            </a>
                            <a href="https://www.twitter.com" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                <Twitter size={20} />
                            </a>
                            <a href="https://www.instagram.com" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                <Instagram size={20} />
                            </a>
                            <a href="https://www.linkedin.com" className="text-white/70 hover:text-[#3370C9] transition-colors duration-300">
                                <Linkedin size={20} />
                            </a>
                        </div>
                    </div>
                </div>

                <div className="border-t border-white/10 pt-6 text-center text-white/50 text-sm">
                    <p>&copy; {new Date().getFullYear()} HISABB. All rights reserved.</p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;